import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Organization } from '../../organization/organization.model';
import { Location } from '../../locations/location.model';

@Component({
  selector: 'app-org-location-fields',
  templateUrl: './org-location-fields.component.html',
  styleUrls: ['./org-location-fields.component.scss']
})
export class OrgLocationFieldsComponent implements OnInit {

  @Input() organizations: Organization[];
  @Input() orgId: number;
  @Output() onOrgIdChanged = new EventEmitter<number>();

  public locationList: Location[];
  @Input() locations: Location[];
  @Input() locationId: number;
  @Output() onLocationIdChanged = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.locationList = [...this.locations];

  }

  onOrgIdChange($event) {
    this.orgId = $event;
    this.locationId = 0;
    this.locationList = this.locations.filter((location) => {
      return location.org_id == this.orgId;
    })
    this.onOrgIdChanged.emit(this.orgId);
  }

  onLocationIdChange($event) {
    this.locationId = $event;
    this.onLocationIdChanged.emit(this.locationId);
  }

}
